require("clover/gameGuide/GameGuide")
const CONFIG_PATH = "meta/game_guide_res.json"

let guideObstacleResMap = null
let levelUsedGuideRes = null

function getGuideObstacleResList(item) {
    if (guideObstacleResMap == null) {
        let config =  ResManager.get(CONFIG_PATH);
        guideObstacleResMap = {};
        for (let key in config) {
            guideObstacleResMap[key] = $tableToArray(config[key]);
        }
    }
    let result = []
    if (item.anims) {
        for (let i = 1; i <= $len(item.anims); i++) {
            let res = guideObstacleResMap[item.anims[i].obstName]
            if (isArray(res)) {
                // 后面的引导分开导出，不再用obstacle_anim_res
                let hasSplitedRes = res.some(item => item.includes('obstacle_anim_') && item.endsWith('.plist'))
                if (!hasSplitedRes) {
                    result.push('cocos/obstacle_anim_res.plist')
                }
                result = result.concat(res)
            } else if (typeof res === 'string') {
                result.push(res)
            }
        }
    }
    return result
}

function getGuideOtherResList(item) {
    let result = []
    if (item.images) {
        item.images.forEach(image => image && image.file && result.push(image.file))
    }
    if (item.image) {
        item.image.file && result.push(item.image.file)
    }
    return result
}

// cocos/game_guide.plist cocos/uilibrary_newer_button.csb 会在HomeScene中加载
// 此处若加入List中，退出游戏场景时资源将被卸载
// HomeScene中依赖这些资源的会出现问题

let guideActionResMap = {
    // clickHand: 'cocos/game_guide.plist',
    // swapHand: 'cocos/game_guide.plist',
    board: function (action) {
        let obstacleRes = getGuideObstacleResList(action)
        return ['materials/guide_board.png'].concat(obstacleRes)
    },
    button: 'cocos/game_guide_btn_green_start.csb',
    bubble: function (action) {
        let result = [
            // 'cocos/game_guide.plist',
        ]
        if (action.buttons && $len(action.buttons) > 0)
            // result.push('cocos/uilibrary_newer_button.csb')
        if (action.skipText || action.text) {
            // result.push('font/zzgftongxin_guide.fnt')
        }
        return result
    },
    animalBubbleUp: function (action) {
        return [
            'cocos/game_guide_anim_res.plist',
            'cocos/game_guide_anim1_guideanim_in.csb',
            'cocos/game_guide_anim3_guideanim_front_speak1.csb',
            'cocos/game_guide_anim3_guideanim_front_speak2.csb',
        ].concat(guideActionResMap.bubble(action))
    },
    animalBubbleDown: function (action) {
        return [
            'cocos/game_guide_anim_res.plist',
            'cocos/game_guide_anim1_guideanim_in.csb',
            'cocos/game_guide_anim2_guideanim_left_speak1.csb',
            'cocos/game_guide_anim2_guideanim_left_speak2.csb',
            'cocos/game_guide_anim2_guideanim_left_speak3.csb'
        ].concat(guideActionResMap.bubble(action))
    },
    animalFadeUp: function (action) {
        return [
            'cocos/game_guide_anim_res.plist',
            'cocos/game_guide_anim3_guideanim_front_speak1.csb',
            'cocos/game_guide_anim3_guideanim_front_speak2.csb',
        ].concat(guideActionResMap.bubble(action))
    },
    animalFadeDown: function (action) {
        return [
            'cocos/game_guide_anim_res.plist',
            'cocos/game_guide_anim2_guideanim_left_speak2.csb',
            'cocos/game_guide_anim2_guideanim_left_speak3.csb'
        ].concat(guideActionResMap.bubble(action))
    },
    animalSlideUp: function (action) {
        return [
            'cocos/game_guide_anim_res.plist',
            'cocos/game_guide_anim3_guideanim_front_speak1.csb',
            'cocos/game_guide_anim3_guideanim_front_speak2.csb'
        ].concat(guideActionResMap.bubble(action))
    },
    animalSlideDown: function (action) {
        return [
            'cocos/game_guide_anim_res.plist',
            'cocos/game_guide_anim2_guideanim_left_speak2.csb',
            'cocos/game_guide_anim2_guideanim_left_speak3.csb'
        ].concat(guideActionResMap.bubble(action))
    }
}

guideActionResMap['singleAnimalBubbleUp'] = guideActionResMap['animalBubbleUp']
guideActionResMap['singleAnimalBubbleDown'] = guideActionResMap['animalBubbleDown']
guideActionResMap['singleAnimalFadeUp'] = guideActionResMap['animalFadeUp']
guideActionResMap['singleAnimalFadeDown'] = guideActionResMap['animalFadeDown']
guideActionResMap['singleAnimalSlideUp'] = guideActionResMap['animalSlideUp']
guideActionResMap['singleAnimalSlideDown'] = guideActionResMap['animalSlideDown']

function getLevelGuideResList(levelId) {
    levelUsedGuideRes = []
    let guides = GameGuide.getInstance().getLevelGuide(levelId)
    let result = []
    for (let i = 1; i < guides.length; i++) {
        let actions = guides[i].action
        for (let j = 1; j < actions.length; j++) {
            let action = actions[j]
            for (let k = 1; k < action.length; k++) {
                let assets = guideActionResMap[action[k].type]
                if (typeof assets === 'function') {
                    assets = assets(action[k])
                }
                if (isArray(assets)) {
                    for (let l = 0; l < assets.length; l++) {
                        result.push(assets[l])
                        levelUsedGuideRes.push(assets[l])
                    }
                } else if (typeof assets === 'string') {
                    result.push(assets)
                    levelUsedGuideRes.push(assets)
                }
                result = result.concat(getGuideOtherResList(action[k]))
            }
        }
    }
    return result
}

function getLevelUsedGuideResList(){
    return levelUsedGuideRes;
}

console.log("=================================================================================")
console.log(JSON.stringify(guideObstacleResMap))

module.exports = {getLevelGuideResList, getLevelUsedGuideResList}